import Drawflow from 'drawflow';
import { useEffect, useRef, useState } from 'react';
import { createRoot } from 'react-dom/client';

const NodeBox = (e) => {
    console.log(e);
    return (
        <div>
            <input type="text" df-name disabled />
        </div>
    );
};

const DrawflowReactor = ({ term, condition, fn }) => {
    const drawflowRef = useRef(null);
    let editor = useRef(null);
    const [height, setHeight] = useState('800px');

    const GAP = 40;

    let mergeTermCond = term.items.concat(condition.items);

    useEffect(() => {
        const id = drawflowRef.current;
        editor.current = new Drawflow(id);
        editor.current.start();

        // editor.current.editor_mode = 'fixed'; // Only scroll
        editor.current.draggable_inputs = false;
        editor.current.zoom_max = 1;
        editor.current.zoom_min = 1;
        editor.current.registerNode((props) => {
            // console.log('registerNode');
            return NodeBox;
        });
        editor.current.on('connectionCreated', ({ output_id, input_id, output_class, input_class }) => {
            const nodeInfoOutput = editor.current.getNodeFromId(output_id);

            if (nodeInfoOutput.outputs[output_class].connections.length > 1) {
                const removeConnectionInfo = nodeInfoOutput.outputs[output_class].connections[0];
                editor.current.removeSingleConnection(output_id, removeConnectionInfo.node, output_class, removeConnectionInfo.output);

                let q = mergeTermCond[output_id - 1];
                let w = mergeTermCond[removeConnectionInfo.node - 1];
                fn.handleRemove(q, w);
            }

            const nodeInfoInput = editor.current.getNodeFromId(input_id);

            if (nodeInfoInput.inputs[input_class].connections.length > 1) {
                const removeConnectionInfo = nodeInfoInput.inputs[input_class].connections[0];
                editor.current.removeSingleConnection(output_id, input_id, output_class, input_class);

                let q = mergeTermCond[output_id - 1];
                let w = mergeTermCond[removeConnectionInfo.node - 1];
                fn.handleRemove(q, w);
            } else {
                let t = mergeTermCond[output_id - 1];
                let c = mergeTermCond[input_id - 1];
                fn.handleJoin(t, c);
            }
        });
        editor.current.on('connectionRemoved', ({ output_id, input_id, output_class, input_class }) => {
            editor.current.removeSingleConnection(output_id, input_id, output_class, input_class);
            let q = mergeTermCond[output_id - 1];
            let w = mergeTermCond[input_id - 1];
            fn.handleRemove(q, w);
        });
        // editor.current.on('connectionSelected', ({output_id, input_id, output_class, input_class}) => {
        //     editor.current.removeSingleConnection(output_id, input_id, output_class, input_class);
        //     let q = mergeTermCond[output_id-1];
        //     let w = mergeTermCond[input_id-1];
        //     fn.handleRemove(q, w)
        // })
        // editor.current.on('contextmenu', (event) => {
        //     console.log(event);
        // })
        editor.current.on('clickEnd', () => {
            editor.current.editor_selected = null;
        });

        let width = document.querySelector('#drawflow').clientWidth;
        let posX = 320;
        let posYTerm = 0;
        let posYCondition = 0;

        if (width > 720) {
            posX = 500;
        }

        // console.log(term)
        term.items.map((item, index) => {
            // console.log(item)
            editor.current.addNode(item.label, 0, 1, 0, posYTerm, 'term-item', {}, item.label, false);
            let termItems = document.querySelectorAll('.term-item');
            let lastItem = termItems[termItems.length - 1];
            posYTerm += lastItem.offsetHeight + GAP;
        });

        condition.items.map((item, index) => {
            editor.current.addNode(item.label, 1, 0, posX, posYCondition, 'condition-item', {}, item.label, false);
            // console.log(editor.current);
            let conditionItems = document.querySelectorAll('.condition-item');
            let lastItem = conditionItems[conditionItems.length - 1];
            posYCondition += lastItem.offsetHeight + GAP;
        });

        let newHeight = Math.max(posYTerm, posYCondition) + 'px';
        setHeight(newHeight);

        const domContainer = document.querySelectorAll('.NodeBox .drawflow_content_node');
        domContainer.forEach((element, i) => {
            const root = createRoot(element);
            root.render(<NodeBox />);
        });

        return () => {
            // Cleanup when the component unmounts
            editor.current.clear();
        };
    }, []);

    const styles = {
        drawflow: {
            position: 'relative',
            width: '100%',
            height: height,
            border: 'none',
        },
    };

    return <div id="drawflow" style={styles.drawflow} ref={drawflowRef}></div>;
};

export default DrawflowReactor;
